export default "__VITE_ASSET__CR7sshLh__"